import { productList } from '@/pages/backend/components/campForm/index';

/**
 * @author: Wangwei
 * @description: 打卡营首页
 */
export interface Batch {
  id: string;
  cardCampId: string;
  name: string;
  qrCode: string;
  buttonName: string;
  stTime: string;
  enTime: string;
  rewardTime: string;
  earlyStudy: number;
  administrators: string;
  notice: string;
}

interface SimpleCamp {
  id: string;
  name: string;
  product: string;
  ownerId: number;
  ownerName: string;
  visible: number;
  recommendable: number;
  administrators: string;
  cover: string;
  info: string;
  index: number;
}

interface LastStudyNode {
  id: string;
  name: string;
  index: number;
}

interface firstStudyNode {
  id: string;
  name: string;
  index: number;
}

export interface CampStudyVO {
  createdBy: number;
  createdTime: string;
  lastModifiedBy: number;
  lastModifiedTime: string;
  revision: number;
  id: string;
  cardCampId: string;
  batchId: string;
  campStudyState: number;
  campScore: number;
  learningDuration: number;
  allNode: number;
  successNode: number;
  allStudent: number;
  myRanking: number;
  lastStudyNode: LastStudyNode;
  firstStudyNode: firstStudyNode;
  batch: Batch;
  simpleCamp: SimpleCamp;
}

export interface PageCampVO {
  id: string;
  name: string;
  product: string;
  ownerId: number;
  ownerName: string;
  visible: number;
  recommendable: number;
  administrators: string;
  cover: string;
  info: string;
  index: number;
  campAllStudent: number;
  signUp: boolean;
  finishRule: TFinishRule;
  recruitPage: RecruitPage;
  batchInfo: Batch;
  nextBatchInfo: Batch;
  firstBatchInfo: Batch;
  authBatchInfo: Batch;
  superAdmin: boolean;
  studentCampSuccess: CampStudyVO;
  campStudyState: number;
}

export function getProductNamesByIds(productIds: any) {
  const product = productList.find((product) => product.value === productIds);
  return product?.label || '[]';
}

export interface ProductVO {
  id: number;
  name: string;
}

// 打卡营
export interface PromotionalImage {
  name?: string;
  pcUrl?: string;
  mobileUrl?: string;
  index: number;
  dynamic: boolean;
}

interface DynamicCommunication {
  dynamicCommunication: boolean;
  index: number;
}

export interface RecruitPage {
  promotionalImages: PromotionalImage[];
  dynamicCommunication?: DynamicCommunication;
}

export interface TConditionForSuccess {
  finishNodes: string[];
  selectedFinishNodes: boolean;
  earnCredits: number;
  selectedEarnCredits: boolean;
}

export interface TFinishRule {
  conditionForSuccess: TConditionForSuccess;
  excellentCreditLimit: number;
  promptAfterSuccess: string;
  downloadReportBtnText: string; // 下载报告按钮文案
}

export interface CampVO {
  id: string;
  name: string;
  product: string;
  ownerId: number;
  ownerName: string;
  visible: number;
  recommendable: number;
  administrators: string;
  cover: string;
  info: string;
  recruitPage: RecruitPage;
  finishRule: TFinishRule;
  index: number;
}

export interface BatchInfoVO {
  id: string;
  cardCampId: string;
  name: string;
  qrCode: string;
  buttonName: string;
  stTime: string;
  enTime: string;
  earlyStudy: number;
  administrators: string;
  notice: string;
  camp: CampVO;
  listBatch: Batch[];
}
